module.exports = __webpack_public_path__ + "static/media/not_authorized.1c8c51e6.svg";